<div
  [hidden]="!selected"
  class="phone-node-menu flow-menu"
  (click)="$event.stopPropagation()"
  #nodeMenuElement
>
  <div class="heading">
    <div
      *ngFor="let tab of tabs"
      class="tab"
      [ngClass]="{
        error: formsInvalidity[tab.invalidProperty] && currentTab.touched,
        selected: currentTab === tab
      }"
      (click)="currentTab = tab; currentTab.touched = true"
    >
      {{ tab.name }}
    </div>
  </div>
  <div *ngIf="currentTab?.code === 'content'" class="content">
    <div class="content-box">
      <div class="container-row template-row">
        <lhpe-select
          controlName="template"
          placeholder="Template"
          [formGroup]="currentTab.formGroup!"
          [options]="templateOptions"
          displayValue="name"
          [optionIsSelf]="true"
          [required]="true"
        >
        </lhpe-select>
        <div class="or">or</div>
        <button mat-button color="lightGreen" (click)="createNewTemplate()">
          New
        </button>
      </div>
      <div class="container-row">
        <lhpe-select
          controlName="frequency"
          placeholder="Frequency"
          [formGroup]="currentTab.formGroup!"
          [options]="signalFrequencies"
          displayValue="label"
          optionValue="value"
          [required]="true"
        >
        </lhpe-select>
      </div>

      <div class="container-row">
        <lhpe-select
          controlName="trackingCategory"
          placeholder="Tracking category"
          [formGroup]="currentTab.formGroup!"
          [options]="trackingCategoryOptions"
          displayValue="name"
          optionValue="id"
          [required]="true"
        >
        </lhpe-select>
      </div>

      <div class="heading" *ngIf="contentAssistantIntegration !== undefined">
        <div
          *ngFor="let tab of contentTabs"
          class="tab"
          [ngClass]="{
            error: formsInvalidity[tab.invalidProperty] && currentTab.touched,
            selected: currentContentTab === tab
          }"
          (click)="contentTabClicked(tab)"
        >
          <svg-icon
            *ngIf="tab.icon"
            class="icon"
            src="assets/svg/{{tab.icon!}}.svg"
            [svgStyle]="{
              'width.px': '18',
              'height.px': '18'
            }"
          ></svg-icon>
          {{ tab.name }}
        </div>
      </div>

      <div *ngIf="currentContentTab?.code === 'content'" class="tabContent">
        <div class="container-row">
          <lhpe-input
            controlName="notificationHeadline"
            placeholder="Push notification and content headline"
            [formGroup]="currentTab.formGroup!"
            [required]="true"
          >
          </lhpe-input>
        </div>
  
        <div class="container-row">
          <lhpe-textarea
            controlName="notificationText"
            placeholder="Push notification text"
            [formGroup]="currentTab.formGroup!"
            [required]="true"
            [rows]="3"
          >
          </lhpe-textarea>
        </div>
  
        <div class="container-row editor" [ngClass]="{'invalid': currentTab.formGroup!.touched && currentTab.formGroup!.controls.bodyContent.hasError('required')}">
          <editor apiKey="ck8ze3gv5uipup94hehaevo1z6p1h9eh4wzi0h86qad6xam6" [init]="{plugins: 'link', menubar: false, statusbar: false, height: '300px', width: '100%'}" [(ngModel)]="bodyContentModel" (ngModelChange)="bodyContentChanged($event)" ></editor>
        </div>
  
        <div class="redemptions-feedback">
          <div class="redemptions-feedback-heading">Redemptions and feedback</div>
          <div class="options">
            <div class="redemption">
              Redemption code
              <mat-slide-toggle
                color="lightGreen"
                [formControl]="currentTab.redemptionControl!"
                [checked]="currentTab.formGroup!.controls.redemption.value"
              >
                {{
                  currentTab.formGroup!.controls.redemption.value
                    ? "Enabled"
                    : "Disabled"
                }}
              </mat-slide-toggle>
            </div>
            <div class="feedback">
              Thumbs up/down input
              <mat-slide-toggle
                color="lightGreen"
                [formControl]="currentTab.feedbackControl!"
                [checked]="currentTab.formGroup!.controls.feedback.value"
              >
                {{
                  currentTab.formGroup!.controls.feedback.value
                    ? "Enabled"
                    : "Disabled"
                }}
              </mat-slide-toggle>
            </div>
          </div>
        </div>
  
        <div class="preview">
          <button
            mat-button
            color="fiord"
            [disabled]="currentTab.formGroup!.invalid"
            (click)="preview('mobilePush')"
          >
            Preview
          </button>
        </div>
      </div>

      <div *ngIf="currentContentTab?.code === 'assistant' && contentAssistantIntegration !== undefined" class="assistant">
        <app-assistant-chat [integration]="contentAssistantIntegration" [content]="contentAssistantData" [previewFn]="this.preview.bind(this)" [closeFn]="this.endAssistant.bind(this)"></app-assistant-chat>
      </div>

      
    </div>
  </div>

  <div
    *ngIf="currentTab?.code === 'tagsAndConversion'"
    class="tags-and-conversions"
  >
    <div class="content-box">
      <div class="container-row search-tags-row">
        <div class="input-box icon-input-box">
          <svg-icon src="assets/svg/magnifier.svg"></svg-icon>

          <mat-form-field>
            <input
              matInput
              (keyup)="applyTagFilter()"
              matInput
              type="text"
              [(ngModel)]="tagSearchValue"
              placeholder="Search for tags in your library"
            />
          </mat-form-field>
        </div>
        <button mat-button color="lightGreen" (click)="createTag()">
          Create
        </button>
      </div>
      <div class="container-row">
        <lhpe-option-snack-group type="clickable">
          <lhpe-option-snack
            *ngFor="let tag of filteredTags"
            [option]="tag"
            [name]="tag"
            (optionClicked)="tagSelected(tag)"
          >
          </lhpe-option-snack>
        </lhpe-option-snack-group>
      </div>
      <ng-container *ngIf="selectedTags.length">
        <div class="container-row">
          <div class="row-label">Applied-tags:</div>
        </div>
        <div class="container-row">
          <lhpe-option-snack-group>
            <lhpe-option-snack
              *ngFor="let tag of selectedTags"
              [option]="tag"
              [name]="tag"
              (optionRemoved)="tagRemoved(tag)"
            >
            </lhpe-option-snack>
          </lhpe-option-snack-group>
        </div>
      </ng-container>
      <div class="container-row">
        <div class="row-label">Conversion tracking</div>
      </div>
      <div
        class="container-row"
      >
      <button mat-button [color]="selectedLocations.length > 0 ? 'lightGreen' : 'warn'" (click)="selectLocations()">{{selectedLocations.length}} {{selectedLocations.length === 1 ? 'Location' : 'Locations'}}</button>
      </div>

      <div class="container-row">
        <lhpe-select
          controlName="conversions"
          placeholder="Track conversions for"
          [formGroup]="currentTab.formGroup!"
          [options]="conversionTrackingOptions"
          optionValue="value"
          displayValue="label"
        >
        </lhpe-select>
      </div>
    </div>
  </div>

  <div *ngIf="currentTab?.code === 'payloadOrOffer'" class="payload-or-offer">
    <div class="content-box">
      <div class="payload" *ngIf="hasPayloadForm">
        <div class="container-row">
          <div class="row-label">Payload</div>
        </div>
        <div *ngFor="let property of payloadProperties" class="container-row">
          <lhpe-input
            class="property-key"
            [control]="property.keyControl"
            placeholder="Enter Key Name"
          >
          </lhpe-input>

          <lhpe-input
            class="property-value"
            [control]="property.valueControl"
            [placeholder]="property.keyNamePrefix + ' Key Value'"
            [matAutocomplete]="value"
          >
          </lhpe-input>

          <mat-autocomplete #value="matAutocomplete">
            <mat-option
              *ngFor="let option of property.valueAutoCompleteOptions"
              [value]="option.value"
              (click)="addPayloadProperty(property)"
            >
              [{{ option.value }}] {{ option.label }}
            </mat-option>
          </mat-autocomplete>

          <button
            *ngIf="property.completed"
            mat-button
            color="warn"
            (click)="removePayloadProperty(property)"
          >
            <svg-icon
              src="assets/svg/trashcan.svg"
              [svgStyle]="{
                'width.px': '22.5',
                'height.px': '22.298'
              }"
              svgClass="white"
            ></svg-icon>
          </button>

          <button
            *ngIf="!property.completed && !property.keyNameIsLookup"
            mat-button
            color="lightGreen"
            [disabled]="
              property.keyControl.invalid || property.valueControl.invalid
            "
            (click)="addPayloadProperty(property)"
          >
            ADD
          </button>
        </div>
      </div>
      <div *ngIf="hasOffer">
        <div class="container-row">
          <div class="row-label">Offer</div>
        </div>
        <div class="container-row">
          <lhpe-select
            placeholder="Offer"
            [control]="offerControl"
            [options]="offers"
            [optionIsSelf]="true"
            displayValue="name"
          >
          </lhpe-select>
        </div>

        <ng-container *ngIf="offerControl?.value?.id !== null">
          <ng-container *ngFor="let field of offerFields">
            <div *ngIf="!field.hidden" class="container-row">
              <lhpe-select
                *ngIf="field.type === 'Select'"
                [placeholder]="field.label"
                [control]="field.control"
                [options]="field.options"
                displayValue="label"
                [optionIsSelf]="true"
                [required]="field.required"
                [matTooltip]="field.hint"
                matTooltipPosition="below"
              >
              </lhpe-select>

              <lhpe-input
                *ngIf="field.type === 'String'"
                [placeholder]="field.label"
                [control]="field.control"
                [required]="field.required"
                [matTooltip]="field.hint"
                matTooltipPosition="below"
              >
              </lhpe-input>

              <lhpe-input
                *ngIf="field.type === 'Integer'"
                [placeholder]="field.label"
                [control]="field.control"
                [required]="field.required"
                [matTooltip]="field.hint"
                matTooltipPosition="below"
                type="number"
              >
              </lhpe-input>

              <div
                *ngIf="field.type === 'Date'"
                class="date"
                [matTooltip]="field.hint"
                matTooltipPosition="below"
              >
                <div class="text">{{ field.label }}</div>
                <button
                  mat-button
                  class="icon-btn"
                  (click)="datePicker.openPicker()"
                >
                  <svg-icon
                    src="assets/svg/calendar.svg"
                    [svgStyle]="{
                      'width.px': '26.5',
                      'height.px': '26.5'
                    }"
                    svgClass="grey"
                  >
                  </svg-icon>
                </button>
                <div class="column">
                  <div class="row">
                    <lhpe-datepicker
                      #datePicker
                      [hideToggle]="true"
                      placeholder="mm/dd/yyyy"
                      [control]="field.control"
                      [required]="field.required"
                    >
                    </lhpe-datepicker>
                  </div>
                  <div class="row">
                    <div class="time-input-box">
                      <ngx-mat-timepicker-field
                        color="primary"
                        [defaultTime]="field.timeString"
                        (timeChanged)="onTimePickerTimeChanged($event, field)"
                      ></ngx-mat-timepicker-field>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="field.type === 'Interval'" class="interval">
                <lhpe-input
                  [placeholder]="field.label"
                  [control]="field.control"
                  [required]="field.required"
                  [matTooltip]="field.hint"
                  matTooltipPosition="below"
                  type="number"
                >
                </lhpe-input>
                <lhpe-select
                  placeholder="Interval"
                  [control]="field.intervalControl"
                  [options]="intervalOptions"
                  [optionIsSelf]="true"
                  [required]="field.required"
                >
                </lhpe-select>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>
